import * as types from './actionTypes'

export const initialState = {
  vehicleByPlate: {},
  fetchedModels: {},
  registeredVehicles: {},
}

const NewFleet = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.FETCH_VEHICLE_BY_PLATE: {
      return {
        ...state,
        vehicleByPlate: {
          [payload.vehicleFormType]: payload.newVehicle,
        },
      }
    }
    case types.FETCH_MODELS_BY_BRAND: {
      return {
        ...state,
        fetchedModels: {
          ...state.fetchedModels,
          [payload.id]: payload.models,
        },
      }
    }
    case types.FETCH_SPECIFIC_VEHICLE_DATA: {
      return {
        ...state,
        registeredVehicles: {
          ...state.registeredVehicles,
          [payload.plate]: payload.data,
        },
      }
    }
    default:
      return state
  }
}

export default NewFleet
